/*
 * @Descripttion: 关于我们
 * @version:
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2022-07-21 09:42:26
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2023-12-20 14:30:19
 */

const about = {
  about: {
    title: '公司简介',
    des: 'Company profile',
    list: ['杭州脉流科技有限公司（简称“脉流科技”）成立于2017年6月，是一家面向全球提供领先的心脑血管疾病智能解决方案的国家级高新技术企业。', '作为心脑血管智能诊疗领域的领跑者，致力于成为全球领先的心脑血管疾病精准临床生态平台，脉流科技秉持“让医疗更精准”的理念，依靠在医学大数据、计算仿真、血流动力学、人工智能算法等方面的技术沉淀，推出一系列覆盖心脑血管领域平台化管线产品，实现筛查、检测、诊断、精准手术及治疗全流程，构建覆盖院内外场景的精准临床生态闭环，为医院、影像中心、体检机构和患者提供精准化和个性化诊疗服务，带来更好的诊疗体验。']
  },
  culture: {
    title: '企业文化',
    list: [
      {
        title: '愿景',
        des: '让医疗更精准'
      }, {
        title: '使命',
        des: '面向全球提供领先的心脑血管疾病智能解决方案'
      }, {
        title: '价值观',
        des: '创新、精准、高效、卓越'
      }, {
        title: '口号',
        des: '领跑心脑血管智能诊疗'
      }
    ]
  },
  international: {
    title: '国际影响力',
    list: [
      '凭借在深度学习算法、血流动力学分析、医学图像算法等领域的深厚积累，成立至今，脉流科技创新产品不断获得了全球行业的认可。',
      '2019年12月，在以色列举行的世界心血管创新大会（ICI）上，脉流科技无创功能学评估系列产品AccuFFR，获得了2019年度心血管领域最佳创新奖。',
      '2020年3月，脉流科技自主研发的AccuFFR系列产品获得欧盟CE注册证，脉流科技成为CE市场上全球首家同时具有CT-FFR和angio-FFR产品的公司。',
      '2020年11月，在2020第四届世界生命科技大会上，脉流科技从100个创新项目中脱颖而出，获得SATOL生命科技创新奖唯一一等奖。',
      '2021年4月，脉流科技三款产品同步获得中国医疗器械上市注册证，颅内动脉瘤辅助诊断系统AneuFlow成为国内首个基于血流动力学的颅内动脉瘤评估上市产品。',
      '2022年2月，脉流科技颅内动脉瘤介入手术计划产品AneuSize获批进入国家三类创新医疗器械绿色通道。',
      '2022年6月，脉流科技颅内动脉瘤手术计划产品AneuGuide获得美国FDA 510(k)注册证，成为国内唯一密网支架手术计划产品在美国获批。',
      '2022年12月，脉流科技自主研发的AccuCTP获的FDA 510(k)注册证，成为目前国内唯一取得中、美两国药监局上市许可的CTP影像分析软件。',
      '2023年1月，脉流科技冠脉微循环功能学评估产品AccuIMR获批进入国家三类创新医疗器械绿色通道。',
      '2023年2月，脉流科技AccuICAS获得美国FDA 510(k) 注册证，成为全球唯一获批颅内狭窄功能学评估产品。',
      '2023年3月，脉流科技冠脉功能学评估设备AccuFFRangio Plus获批国家三类医疗器械注册证，并于同月获得美国FDA 510 (k)注册证。'
    ]
  },
  history: {
    title: '发展历程',
    year: [2023, 2022, 2021, 2020, 2019, 2018, 2017],
    list: [
      {
        time: 2023,
        des: [
          {
            time: '1月',
            content: 'AcculMR通过国家三类创新医疗器械特别审查申请'
          }, {
            time: '1月',
            content: '荣获杭州市“西湖明珠工程”领军型创新创业团队'
          }, {
            time: '2月',
            content: 'AccuICAS获美国FDA 510(k)，是全球首个获得批准的颅内狭窄功能学评估产品'
          }, {
            time: '3月',
            content: 'AccuFFRangio Plus获美国FDA 510(k)，进一步开拓海外多元化商业模式'
          }, {
            time: '3月',
            content: '“血流导向装置精准治疗复杂颅内动脉瘤中的临床应用”项目入选广州地区唯一脑血管病领域临床重大技术建设名单'
          }, {
            time: '3月',
            content: '在3C会议期间，首次实现了冠脉的功能学AccuFFRangio、虚拟支架后FFR预测以及IMR的联合诊断在手术中的运用，具有革新疗法的里程碑意义'
          }, {
            time: '4月',
            content: 'AccuICAS、AneuGuide在世界神经介入最高学术水平的WLNC上亮相，开创世界颅内功能学和密网手术规划先河'
          }, {
            time: '5月',
            content: 'ICAS-MT颅内功能学多中心临床正式启动，为卒中防控提供高级别循证医学证据'
          }, {
            time: '6月',
            content: '第三次荣登“2022未来医疗100强·创新医疗器械榜TOP100”，并荣获“未来医疗100强·澎橙奖·年度创新企业奖”'
          }, {
            time: '7月',
            content: '“微循环慢血流多中心临床试验启动讨论会”成功召开，推动冠脉微循环领域新认知'
          }, {
            time: '8月',
            content: 'AccuIMR荣获2023年度最具创新性医疗科技产品（解决方案）TOP100'
          }, {
            time: '8月',
            content: '脉流科技创始人兼CEO向建平博士入围“滨江工匠”'
          }, {
            time: '11月',
            content: '荣获中国医药教育协会进步奖三等奖'
          }, {
            time: '11月',
            content: '与浙江医院共建省级工程研究中心（脑血管疾病精准医疗浙江省工程研究中心月，获批设立《浙江省高新技术企业研究开发中心》'
          }, {
            time: '11月',
            content: '向建平入选2023脑科学与类脑智能科创新青年30人'
          }
        ]
      },
      {
        time: 2022,
        des: [
          {
            time: '2月',
            content: '颅内动脉瘤手术计划产品AneuSize获批进入国家三类创新医疗器械绿色通道'
          }, {
            time: '5月',
            content: '冠脉功能学评估产品QFR-A产品获得中国NMPA注册证'
          }, {
            time: '6月',
            content: '荣登“2022未来医疗100强•创新医疗器械榜TOP100”，荣获“未来医疗100强•澎橙奖•年度创新企业奖”'
          }, {
            time: '6月',
            content: '颅内动脉瘤手术计划产品AneuGuide成功获批美国FDA 510(k)'
          }, {
            time: '8月',
            content: '与中国卒中学会共同发起“脑血管病影像辅助诊断应用一智绘云学院”项目'
          }, {
            time: '8月',
            content: '举办全国首期“大脉加油站暨合作商培训大会”'
          }, {
            time: '9月',
            content: '冠脉功能学评估产品AccuOCT产品获中国NMPA注册证'
          }, {
            time: '11月',
            content: '脉流科技创始人兼CEO向建平博士入选2022年国家级领军人才'
          }, {
            time: '12月',
            content: '颅内CT灌注分析产品AccuCTP获批美国FDA 510(k)'
          }, {
            time: '12月',
            content: '与东方脑血管病创新俱乐部成立OCI血流动力学联合实验室'
          }
        ]
      },
      {
        time: 2021,
        des: [
          {
            time: '4月',
            content: '颅内动脉瘤血流动力学评估产品AneuFlow-01/03/04产品获中国NMPA注册证'
          }, {
            time: '4月',
            content: '冠脉功能学评估产品AccuAngio产品获中国NMPA注册证'
          }, {
            time: '4月',
            content: '冠脉功能学评估产品AccuCT产品获中国NMPA注册证'
          }, {
            time: '5月',
            content: '在OCC大会举行“心脑同智，功能先行”心脑血管功能学评估产品上市发布会'
          }, {
            time: '6月',
            content: '完成B轮近亿元融资'
          }, {
            time: '9月',
            content: '冠脉功能学评估产品AccuFFRangio获美国FDA注册证'
          }, {
            time: '10月',
            content: '与心血管医生创新俱乐部CCl成立血流动力学联合实验室'
          }, {
            time: '10月',
            content: '颅内动脉瘤手术计划产品AneuGuide进入创新绿色通道，获得中国NMPA注册证'
          }, {
            time: '12月',
            content: '颅内CT灌注分析产品AccuCTP产品获中国NMPA注册证'
          }
        ]
      }, {
        time: 2020,
        des: [
          {
            time: '3月',
            content: '冠脉功能学评估AccuFFR系列产品获欧盟CE注册证 '
          }, {
            time: '5月',
            content: '荣获“中国医疗健康产业最佳新锐奖”'
          }, {
            time: '7月',
            content: '颅内动脉瘤形态学分析产品AneuFlow-02获中国NMPA注册证'
          }, {
            time: '9月',
            content: '冠脉功能学评估AccuFFR系列产品获得“浙江省卫生科技成果转化金奖”'
          }, {
            time: '11月',
            content: '荣获第四届世界生命科技大会唯一“生命科技创新一等奖”'
          }
        ]
      }, {
        time: 2019,
        des: [
          {
            time: '5月',
            content: '在OCC大会，推出CTO老伙计病例系统'
          }, {
            time: '6月',
            content: '完成A轮数千万融资'
          }, {
            time: '9月',
            content: '在QICC大会推出冠脉功能学评估AccuFFR三大系列产品，并进行手术直播'
          }, {
            time: '12月',
            content: '荣获“国家高新技术企业”'
          }, {
            time: '12月',
            content: '荣登“2019未来医疗100强榜单”'
          }, {
            time: '12月',
            content: '完成A+轮数千万融资，引入战略投资者国药资本'
          }, {
            time: '12月',
            content: '冠脉功能学评估AccuFFR系列产品在以色列获得世界心血管创新大会 (ICl)年度心血管领域最佳创新奖'
          }
        ]
      }, {
        time: 2018,
        des: [
          {
            time: '4月',
            content: '入选杭州滨江“5050”重点支持企业'
          }, {
            time: '5-8月',
            content: '获得杭州市重点培育企业，浙江省科技型中小企业、国家科技型中小企业'
          }, {
            time: '9月',
            content: '在QICC大会上推出冠脉功能学评估AccuFFR产品'
          }
        ]
      }, {
        time: 2017,
        des: [
          {
            time: '6月',
            content: '脉流科技成立'
          }, {
            time: '10月',
            content: '完成千万天使轮融资'
          }
        ]
      }
    ]
  }
}

export default about
